import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import biennale_45lang_45global from "/app/middleware/biennale-lang.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  biennale_45lang_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}